module.exports = __webpack_public_path__ + "img/reload.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/reload.png
// module id = 374
// module chunks = 0